const Box = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 40 40' fill='currentColor' {...props}>
    <path
      d='M20.4642 2.78179C20.1662 2.66258 19.8338 2.66258 19.5358 2.78179L4.61573 8.7498L20 14.9035L35.3843 8.7498L20.4642 2.78179ZM37.5 10.5961L21.25 17.0961V36.9035L37.5 30.4035V10.5961ZM18.75 36.9035V17.0961L2.5 10.5961V30.4035L18.75 36.9035ZM18.6073 0.460595C19.5013 0.102979 20.4987 0.102979 21.3927 0.460595L39.2142 7.5892C39.6888 7.77903 40 8.23867 40 8.7498V30.4035C40 31.4258 39.3776 32.345 38.4285 32.7247L20.4642 39.9104C20.1662 40.0296 19.8338 40.0296 19.5358 39.9104L1.57152 32.7247C0.622378 32.345 0 31.4258 0 30.4035V8.7498C0 8.23867 0.311189 7.77903 0.785762 7.5892L18.6073 0.460595Z'
      fill='currentColor'
    />
  </svg>
);

export default Box;
